export default __webpack_public_path__ + "static/media/i219hp.d62b13d7.webp";